import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {PageState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class PageQuery extends QueryEntity<PageState> {

  constructor(protected store: Store) {
    super(store);
  }

}
